import ServiciosGeneral from "./ServiciosGeneral";
// import axios from './axios'
// const llamarServidor=(ruta)=>(setCtl,setCargando,body)=>{
//     setCargando(true);
//         axios.get(ruta,body)
//         .then(response=>{
//           setCtl(response.data);
//           setCargando(false);
//         })
//         .catch(error=>{
//           setCtl([]);
//           // console.log(error)
//           setCargando(false);
//         });
//     }
//     const llamarServidorRespuesta=(ruta)=>(respuesta,setCargando,body)=>{
//       respuesta(1,ruta,[]);
//       setCargando(true);
//           axios.post(ruta,body)
//           .then(response=>{
//             setCargando(false);
            
//             if(response.status===200&&response.data.status!=undefined)
//               respuesta(response.data.status,response.data.mensaje,response.data.data);
//             else
//               respuesta(-5,"ERROR DESCONOCIDO");
              
//           })
//           .catch(error=>{
//             respuesta(-1,'Error de servidor');
//             // console.log(error)
//             setCargando(false);
//           });
//       }
const servicios={
  proveedoresInt: ServiciosGeneral.llamarServidor('catalogos/proveedoresInt'),
  proveedoresAll: ServiciosGeneral.llamarServidor('catalogos/proveedoresAll'),
  proveedoresCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/proveedoresCreate'),
  proveedoresUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/proveedoresUpdate'),
  proveedoresDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/proveedoresCambioEstatus'),

  cuentaBancariaInt: ServiciosGeneral.llamarServidor('catalogos/cuentaBancariaInt'),
  cuentaBancariaCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/cuentaBancariaCreate'),
  cuentaBancariaUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/cuentaBancariaUpdate'),
  cuentaBancariaDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/cuentaBancariaCambioEstatus'),
  
  personasAll: ServiciosGeneral.llamarServidor('Catalogos/personasAll'),
  personasCreate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/personasCreate'),
  personasUpdate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/personasUpdate'),
  personasDown: ServiciosGeneral.llamarServidorRespuesta('Catalogos/personasCambioEstatus'),

  gruposAll: ServiciosGeneral.llamarServidor('Catalogos/gruposAll'),
  gruposCreate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/gruposCreate'),
  gruposUpdate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/gruposUpdate'),
  gruposDown: ServiciosGeneral.llamarServidorRespuesta('Catalogos/gruposCambioEstatus'),

  tareasAll: ServiciosGeneral.llamarServidor('Catalogos/tareasAll'),
  tareasCreate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/tareasCreate'),
  tareasUpdate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/tareasUpdate'),
  tareasDown: ServiciosGeneral.llamarServidorRespuesta('Catalogos/tareasCambioEstatus'),

  // bancosAll:llamarServidor('catalogos/bancosAll'),
  // bancosCreate:llamarServidorRespuesta('catalogos/bancosCreate'),
  // bancosUpdate:llamarServidorRespuesta('catalogos/bancosUpdate'),
  // bancosDown:llamarServidorRespuesta('catalogos/bancosCambioEstatus'),
  
  proyectosAll: ServiciosGeneral.llamarServidor('/Catalogos/proyectosAll'),
  sistemasAll: ServiciosGeneral.llamarServidor('/Catalogos/sistemas'),
  personasByProy: ServiciosGeneral.llamarServidorRespuesta('/Solicitud/personasByProy'),
  // categoriasCreate:llamarServidorRespuesta('catalogos/categoriasCreate'),
  // categoriasUpdate:llamarServidorRespuesta('catalogos/categoriasUpdate'),
  // categoriasDown:llamarServidorRespuesta('catalogos/categoriasCambioEstatus'),
  
  monedaAll: ServiciosGeneral.llamarServidor('catalogos/monedaAll'),
  monedaCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/monedaCreate'),
  monedaUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/monedaUpdate'),
  monedaDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/monedaCambioEstatus'),
  unidadMedidaAll: ServiciosGeneral.llamarServidor('catalogos/unidadMedidaAll'),
  unidadMedidaCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/unidadMedidaCreate'),
  unidadMedidaUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/unidadMedidaUpdate'),
  unidadMedidaDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/unidadMedidaCambioEstatus'),
  
  tipoAll: ServiciosGeneral.llamarServidor('catalogos/tipoAll'),
  tipoCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoCreate'),
  tipoUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoUpdate'),
  tipoDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoCambioEstatus'),

  centroCostoAll: ServiciosGeneral.llamarServidor('catalogos/centroCostoAll'),
  centroCostoCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/centroCostoCreate'),
  centroCostoUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/centroCostoUpdate'),
  centroCostoDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/centroCostoCambioEstatus'),

  empresaAll: ServiciosGeneral.llamarServidor('catalogos/empresaAll'),
  empresaCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/empresaCreate'),
  empresaUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/empresaUpdate'),
  empresaDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/empresaCambioEstatus'),

  insumoInit: ServiciosGeneral.llamarServidor('catalogos/insumoInit'),
  insumoAll: ServiciosGeneral.llamarServidor('catalogos/insumoAll'),
  insumoCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/insumoCreate'),
  insumoUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/insumoUpdate'),
  insumoDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/insumoCambioEstatus'),
  
  grupoInsumoAll: ServiciosGeneral.llamarServidor('catalogos/grupoInsumoAll'),
  grupoInsumoCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/grupoInsumoCreate'),
  grupoInsumoUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/grupoInsumoUpdate'),
  grupoInsumoDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/grupoInsumoCambioEstatus'),

  tipoInsumoAll: ServiciosGeneral.llamarServidor('catalogos/tipoInsumoAll'),
  tipoInsumoCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoInsumoCreate'),
  tipoInsumoUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoInsumoUpdate'),
  tipoInsumoDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/tipoInsumoCambioEstatus'),

  precioInit: ServiciosGeneral.llamarServidor('catalogos/precioInit'),
  precioCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/precioCreate'),
  precioUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/precioUpdate'),
  precioDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/precioCambioEstatus'),

  sedeAll: ServiciosGeneral.llamarServidor('catalogos/sedeAll'),
  sedeCreate: ServiciosGeneral.llamarServidorRespuesta('catalogos/sedeCreate'),
  sedeUpdate: ServiciosGeneral.llamarServidorRespuesta('catalogos/sedeUpdate'),
  sedeDown: ServiciosGeneral.llamarServidorRespuesta('catalogos/sedeCambioEstatus'),

  //general
  estadoAll: ServiciosGeneral.llamarServidor('catalogos/estadoAll'),
  municipioAll:(setCtl,setCargando,id)=> ServiciosGeneral.llamarServidor('catalogos/municipioAll/'+id)(setCtl,setCargando),


  estadoAll: ServiciosGeneral.llamarServidor('catalogos/estadoAll'),
  subgruposAll:(setCtl,setCargando,id)=>ServiciosGeneral.llamarServidor('catalogos/subgruposAll/'+id)(setCtl,setCargando),

  usuariosAll: ServiciosGeneral.llamarServidor('Catalogos/usuariosAll'),
  usuariosCreate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/usuariosCreate'),
  usuariosUpdate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/usuariosUpdate'),
  usuariosDown: ServiciosGeneral.llamarServidorRespuesta('Catalogos/usuariosCambioEstatus'),

  modulosAll: ServiciosGeneral.llamarServidor('Catalogos/modulosAll'),
  moduloCreate:ServiciosGeneral.llamarServidorRespuesta('Catalogos/moduloCreate'),
  moduloUpdate: ServiciosGeneral.llamarServidorRespuesta('Catalogos/moduloUpdate'),
  moduloDown: ServiciosGeneral.llamarServidorRespuesta('Catalogos/moduloCambioEstatus')
}
export default servicios